import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/translation/languages/translation.setLanguageSupported.mutation.gql"
import type {
  TranslationSetLanguageSupportedMutation,
  TranslationSetLanguageSupportedMutationVariables,
} from "@/v2-backoffice-client/translation/languages/__types__/translation.setLanguageSupported.mutation"

type Options = MutationHookOptions<
  TranslationSetLanguageSupportedMutation,
  TranslationSetLanguageSupportedMutationVariables
>

export function useTranslationSetLanguageSupportedMutation(options?: Options) {
  return useMutation<
    TranslationSetLanguageSupportedMutation,
    TranslationSetLanguageSupportedMutationVariables
  >(mutation, {
    // The toggle changes which languages every other view offers/fills.
    refetchQueries: ["TranslationLanguagesQuery", "TranslationCatalogQuery"],
    ...options,
  })
}
